import React, { useState } from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { Formik, Form } from "formik";
import { IMAGE_URL } from "network";
import {} from "slices/beautyApp/beauticianSlice";
import Swal from "sweetalert2";
import { useGetCategoriesQuery } from "slices/beautyApp/categorySlice";
import { useLinkCategoryMutation } from "slices/beautyApp/beauticianSlice";

function Step3({ val, onNext }) {
  const { data } = useGetCategoriesQuery({});
  const [arryOfservices, setArray] = useState([]);
  const [saveCategory] = useLinkCategoryMutation();

  const initialValues = {
    category: "",
    user_id: val?._id,
  };

  const selectCategory = async (id) => {
    let updatedServices;

    // toggle logic
    if (arryOfservices.includes(id)) {
      updatedServices = arryOfservices.filter((catId) => catId !== id);
    } else {
      updatedServices = [...arryOfservices, id];
    }
    setArray(updatedServices);

    // hit API with updated services
    try {
      let response = await saveCategory({
        user_id: val?._id,
        category: id, // send array of selected services
      });

      if (!response?.data?.data) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.message,
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while saving category",
      });
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {
        if (arryOfservices.length > 0) {
          onNext();
        }
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <Box className="container py-4">
            <Typography variant="h5" gutterBottom>
              Select Category
            </Typography>

            <Box display="flex" flexWrap="wrap" gap={2} mt={2}>
              {data?.data
                ?.filter((item) => item.module_type === "independent")
                .map((item) => {
                  const isSelected = arryOfservices.includes(item._id);
                  return (
                    <Paper
                      key={item._id}
                      onClick={() => selectCategory(item._id)}
                      elevation={isSelected ? 6 : 1}
                      sx={{
                        width: 150,
                        padding: 2,
                        textAlign: "center",
                        border: isSelected
                          ? "2px solid #1976d2"
                          : "1px solid #ccc",
                        cursor: "pointer",
                        backgroundColor: isSelected ? "#e3f2fd" : "#fff",
                        transition: "all 0.3s",
                      }}
                    >
                      <Box
                        crossOrigin="anonymous"
                        component="img"
                        src={`${IMAGE_URL}${item.image}`}
                        alt={item.name}
                        sx={{
                          width: 60,
                          height: 60,
                          objectFit: "cover",
                          mb: 1,
                        }}
                      />
                      <Typography
                        variant="subtitle2"
                        fontWeight={isSelected ? "bold" : "normal"}
                      >
                        {item.name}
                      </Typography>
                    </Paper>
                  );
                })}
            </Box>

            <Box display="flex" justifyContent="flex-end" mt={4}>
              <Button
                type="button"
                variant="contained"
                onClick={onNext}
                disabled={arryOfservices.length === 0} // enabled only if a service is selected
              >
                Next
              </Button>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default Step3;
